import { formatValues } from "src/components/forms/schema_answers_form_component/format_values/index.js";
import { evaluatePredicate } from "src/models/assessment_answers";
import { get } from "lodash";

export function containsRequiredFieldsForSavingAssessmentAnswers(
  schemas,
  assessmentAnswerAnswersJson,
  revisionIsFirstInSeries
) {
  const answersJson = assessmentAnswerAnswersJson;
  const formattedValues = formatValues(answersJson);
  let allRequiredHaveValues = true;

  const evaluateQuestion = (formattedValues, predicate) => {
    return evaluatePredicate({
      answersJson: formattedValues,
      revisionIsFirstInSeries,
      predicate: predicate
    });
  };

  schemas.map(assessmentSchema => {
    if (!allRequiredHaveValues) {
      return;
    }

    const schemaJsonQuestions = get(
      assessmentSchema,
      "attributes.schemaJson.questions",
      []
    );

    for (const index in schemaJsonQuestions) {
      const question = schemaJsonQuestions[index];
      const visiblePredicate = question.visiblePredicateJson;
      const enabledPredicate = question.enabledPredicateJson;

      let visibleQuestion = visiblePredicate
        ? evaluateQuestion(formattedValues, visiblePredicate)
        : true;
      let enabledQuestion = enabledPredicate
        ? evaluateQuestion(formattedValues, enabledPredicate)
        : true;

      if (
        visibleQuestion &&
        enabledQuestion &&
        get(question, "requiredFor", []).includes("save")
      ) {
        if (!answersJson[question["name"]]) {
          answersJson[question["name"]];
          allRequiredHaveValues = false;
          break;
        }
      }
    }
  });

  return allRequiredHaveValues;
}
